import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import fcmService from '../services/fcmService';

export const useNotificationPermission = () => {
  const { user } = useAuth();
  const [permission, setPermission] = useState<NotificationPermission>('default');
  const [fcmToken, setFcmToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  // Inicializar FCM al montar
  useEffect(() => {
    fcmService.initialize();
    const status = fcmService.getPermissionStatus();
    // En Android nativo, getPermissionStatus puede retornar null
    if (status !== null) {
      setPermission(status);
    }
  }, []);

  /**
   * Solicitar permisos de notificación
   */
  const requestPermission = async (): Promise<boolean> => {
    if (!user?.uid) return false;
    
    setLoading(true);
    try {
      const token = await fcmService.requestPermissionAndGetToken(user.uid);
      
      if (token) {
        setFcmToken(token);
        setPermission('granted');
        return true;
      } else {
        const status = fcmService.getPermissionStatus();
        if (status !== null) {
          setPermission(status);
        }
        return false;
      }
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  /**
   * Verificar si las notificaciones están activadas
   */
  const isEnabled = permission === 'granted';

  /**
   * Verificar si se puede pedir permiso
   */
  const canRequest = permission === 'default';

  /**
   * Verificar si fue denegado
   */
  const isDenied = permission === 'denied';

  return {
    permission,
    fcmToken,
    loading,
    isEnabled,
    canRequest,
    isDenied,
    requestPermission,
  };
};
